import React, { useState } from "react";
import { FaInstagram, FaLinkedinIn, FaFacebookF } from "react-icons/fa";
import foxLogo from "../assets/LogoFox-000-removebg-preview.png"; 
import "./Footer.css";

export function Footer() {
  const [email, setEmail] = useState("");
  const handleChange = (e) => setEmail(e.target.value);
  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = `Regjistrim Newsletter`;
    const body = `Email: ${email}`;
    window.location.href =
      `mailto:newsletter@foxacademy.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    setEmail("");
  };

  return (
    <footer className="footer-orange">
      <div className="footer-grid">
        {/* Logo dhe info */}
        <div className="footer-logo-info">
          <img src={foxLogo} alt="Fox Academy Logo" className="footer-logo" />
          <div className="footer-info">
            <div>Xheladin Hana, Pristina 10000</div>
            <div>+383 43 723 623</div>
            <div>© Fox Academy. Të gjitha të drejtat e rezervuara</div>
          </div>
        </div>
        {/* Social Icons */}
        <div className="footer-social">
          <a href="https://www.instagram.com/foxacademy.ks/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
        </div>
        {/* Newsletter */}
        <div className="footer-newsletter">
          <div className="footer-newsletter-title">Regjistrohu për <b>njoftimet tona</b></div>
          <form className="newsletter-form" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Emaili juaj"
              value={email}
              onChange={handleChange}
              required
            />
            <button type="submit">Dërgo</button>
          </form>
          <div className="newsletter-note">
            Njohuria është çelësi i mundësive të pakufishme.
          </div>
        </div>
      </div>
    </footer>
  );
}
